/* eslint-disable no-return-assign */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-access-state-in-setstate */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'

import TypographyHeading1Icon from '@offerzen/zenicon/TypographyHeading1Icon'
import TypographyHeading2Icon from '@offerzen/zenicon/TypographyHeading2Icon'
import TypographyHeading3Icon from '@offerzen/zenicon/TypographyHeading3Icon'
import TypographyBoldIcon from '@offerzen/zenicon/TypographyBoldIcon'
import TypographyItalicIcon from '@offerzen/zenicon/TypographyItalicIcon'
import TypographyStrikethroughIcon from '@offerzen/zenicon/TypographyStrikethroughIcon'
import QuoteIcon from '@offerzen/zenicon/QuoteIcon'
import HyperlinkIcon from '@offerzen/zenicon/HyperlinkIcon'
import ListUnorderedIcon from '@offerzen/zenicon/ListUnorderedIcon'
import ListOrderedIcon from '@offerzen/zenicon/ListOrderedIcon'
import QuestionCircleIcon from '@offerzen/zenicon/QuestionCircleIcon'
import styles, { previewSize, editorSize } from './styles'
import { resizeTextarea } from '../../helpers/formHelpers'
import MarkdownRenderer from '../MarkdownRenderer'
import AccessibleIcon from '../AccessibleIcon'
import FormErrorMessage from '../FormErrorMessage'
import { colors } from '../../themes'

class MarkdownEditor extends Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    activeTab: 'edit',
    previewHeight: '0px',
    toolbarCounter: 0,
    cursorStart: 0,
    cursorEnd: 0,
  }

  componentDidMount() {
    if (this.editor) resizeTextarea(this.editor)
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.editor) return

    if (prevState.activeTab !== this.state.activeTab) {
      this.editor.focus()
    }

    if (this.state.cursorStart !== this.editor.selectionStart || this.state.cursorEnd !== this.editor.selectionEnd) {
      this.editor.setSelectionRange(this.state.cursorStart, this.state.cursorEnd)
    }

    const value = this.props.input.value || this.props.value
    const prevValue = prevProps.input.value || prevProps.value

    // If the value has changed, resize.
    if (value !== prevValue) {
      resizeTextarea(this.editor)
    }
  }

  switchTab = activeTab => {
    this.setState({ activeTab })

    if (this.editor && this.toolbar) {
      this.setState({ previewHeight: `${this.editor.clientHeight + this.toolbar.clientHeight}px` || '0px' })
    }
  }

  insertMarkdown = (selectionPrefix = '', selectionSuffix = '') => {
    if (!this.editor) return

    const text = this.editor.value
    const { selectionStart } = this.editor
    const { selectionEnd } = this.editor

    const preText = text.substring(0, selectionStart)
    const selectedText = text.substring(selectionStart, selectionEnd)
    const postText = text.substring(selectionEnd)

    // Build new values
    let newText = `${preText}${selectionPrefix}${selectedText}${selectionSuffix}${postText}`
    let newStart = selectionStart + selectionPrefix.length
    let newEnd = selectionEnd + selectionPrefix.length

    // If the prefix or suffix is already there, we're undoing
    if (preText.endsWith(selectionPrefix) || (selectionSuffix && postText.startsWith(selectionSuffix))) {
      const newPre = preText.endsWith(selectionPrefix) ? preText.slice(0, -selectionPrefix.length) : preText
      const newPost = selectionSuffix && postText.startsWith(selectionSuffix) ? postText.substring(selectionSuffix.length) : postText

      newText = `${newPre}${selectedText}${newPost}`
      newStart = selectionStart - selectionPrefix.length
      newEnd = selectionEnd - selectionPrefix.length
    } else if (selectedText.startsWith(selectionPrefix) || (selectionSuffix && selectedText.endsWith(selectionSuffix))) {
      let newSelected = selectedText
      newStart = selectionStart
      newEnd = selectionEnd

      if (newSelected.startsWith(selectionPrefix)) {
        newSelected = newSelected.substring(selectionPrefix.length)
        newEnd -= selectionPrefix.length
      }

      if (selectionSuffix && newSelected.endsWith(selectionSuffix)) {
        newSelected = newSelected.slice(0, -selectionSuffix.length)
        newEnd -= selectionSuffix.length
      }

      newText = `${preText}${newSelected}${postText}`
    }

    this.setState({ toolbarCounter: this.state.toolbarCounter + 1, cursorStart: newStart, cursorEnd: newEnd })

    // Call change handlers if any
    const handler = this.props.input.onChange || this.props.onChange
    if (handler) handler(newText)

    // Focus the editor again
    this.editor.focus()
  }

  insertHyperlink = () => {
    if (!this.editor) return

    const text = this.editor.value
    const { selectionStart } = this.editor
    const { selectionEnd } = this.editor

    const preText = text.substring(0, selectionStart)
    const selectedText = text.substring(selectionStart, selectionEnd)
    const postText = text.substring(selectionEnd)

    const newText = `${preText}[${selectedText}](url)${postText}`
    const newStart = selectionStart + selectedText.length + 3 // We added the characters []( before the new selection
    const newEnd = newStart + 3 // The new start + the word url

    this.setState({ toolbarCounter: this.state.toolbarCounter + 1, cursorStart: newStart, cursorEnd: newEnd })

    // Call change handlers if any
    const handler = this.props.input.onChange || this.props.onChange
    if (handler) handler(newText)

    // Focus the editor again
    this.editor.focus()
  }

  insertMarkdownUnorderedList = () => {
    if (!this.editor) return

    const linePrefix = '- '
    const text = this.editor.value
    const { selectionStart } = this.editor
    const { selectionEnd } = this.editor

    const preText = text.substring(0, selectionStart)
    const selectedText = text.substring(selectionStart, selectionEnd)
    const postText = text.substring(selectionEnd)

    let newText = ''
    let newStart = selectionStart
    let newEnd = selectionEnd

    // If the prefix is already there we're removing the list, otherwise we're adding
    if (selectedText.startsWith(linePrefix)) {
      const withoutPrefix = selectedText.substring(linePrefix.length)
      const selectionWithoutMarkdown = withoutPrefix.replace(new RegExp(`\n${linePrefix}`, 'g'), '\n')

      newEnd = selectionEnd - (withoutPrefix.length - selectionWithoutMarkdown.length) - linePrefix.length
      newText = `${preText}${selectionWithoutMarkdown}${postText}`
    } else {
      const selectionWithMarkdown = selectedText.replace(/\n/g, `\n${linePrefix}`)
      let newPreText = preText
      if (preText.length > 0 && !preText.endsWith('\n\n')) {
        newPreText = preText.endsWith('\n') ? `${preText}\n` : `${preText}\n\n`
      }

      if (selectionStart !== selectionEnd) {
        let newPostText = postText
        if (postText.length > 0 && !postText.startsWith('\n\n')) {
          newPostText = postText.startsWith('\n') ? `\n${postText}` : `\n\n${postText}`
        }

        newText = `${newPreText}${linePrefix}${selectionWithMarkdown}${newPostText}`
        newStart = selectionStart + (newPreText.length - preText.length)
        newEnd =
          selectionEnd + (newPreText.length - preText.length) + (selectionWithMarkdown.length - selectedText.length) + linePrefix.length
      } else {
        newText = `${newPreText}${linePrefix}${selectionWithMarkdown}${postText}`
        newStart = selectionStart + (newPreText.length - preText.length) + linePrefix.length
        newEnd = newStart
      }
    }

    this.setState({ toolbarCounter: this.state.toolbarCounter + 1, cursorStart: newStart, cursorEnd: newEnd })

    // Call change handlers if any
    const handler = this.props.input.onChange || this.props.onChange
    if (handler) handler(newText)

    // Focus the editor again
    this.editor.focus()
  }

  insertMarkdownOrderedList = () => {
    if (!this.editor) return

    const text = this.editor.value
    const { selectionStart } = this.editor
    const { selectionEnd } = this.editor

    const preText = text.substring(0, selectionStart)
    const selectedText = text.substring(selectionStart, selectionEnd)
    const postText = text.substring(selectionEnd)

    let newText = ''
    let newStart = selectionStart
    let newEnd = selectionEnd

    // If the selection starts with 1. we're removing the list, otherwise we're adding
    if (/^\d+\./.test(selectedText)) {
      const withoutPrefix = selectedText.replace(/(^\d+\.\s)/, '')
      const selectionWithoutMarkdown = withoutPrefix.replace(/(\n)(\d+\.\s)/g, (_, enter) => enter)

      newEnd = selectionEnd - (withoutPrefix.length - selectionWithoutMarkdown.length) - 3 // 3 is the length of the prefix of the list (e.g. 1. )
      newText = `${preText}${selectionWithoutMarkdown}${postText}`
    } else {
      let lineNumber = 1
      const selectionWithMarkdown = selectedText.replace(/(\n)/g, match => {
        lineNumber += 1
        return `${match}${lineNumber}. `
      })
      let newPreText = preText
      if (preText.length > 0 && !preText.endsWith('\n\n')) {
        newPreText = preText.endsWith('\n') ? `${preText}\n` : `${preText}\n\n`
      }

      if (selectionStart !== selectionEnd) {
        let newPostText = postText
        if (postText.length > 0 && !postText.startsWith('\n\n')) {
          newPostText = postText.startsWith('\n') ? `\n${postText}` : `\n\n${postText}`
        }

        newText = `${newPreText}1. ${selectionWithMarkdown}${newPostText}`
        newStart = selectionStart + (newPreText.length - preText.length)
        newEnd = selectionEnd + (newPreText.length - preText.length) + (selectionWithMarkdown.length - selectedText.length) + 3 // 3 is the lenght of the prefix of the list (1. )
      } else {
        newText = `${newPreText}1. ${selectionWithMarkdown}${postText}`
        newStart = selectionStart + (newPreText.length - preText.length) + 3 // 3 is the lenght of the prefix of the list (1. )
        newEnd = newStart
      }
    }

    this.setState({ toolbarCounter: this.state.toolbarCounter + 1, cursorStart: newStart, cursorEnd: newEnd })

    // Call change handlers if any
    const handler = this.props.input.onChange || this.props.onChange
    if (handler) handler(newText)

    // Focus the editor again
    this.editor.focus()
  }

  render() {
    const { activeTab, previewHeight } = this.state
    const { meta, input, theme, size, className, ...props } = this.props

    const errored = meta.touched && meta.error
    const value = input.value || props.value

    return (
      <div className={className}>
        <ul className={styles.tabsContainer}>
          <li
            className={cx(styles.tab, activeTab === 'edit' && styles.activeTab, errored && styles.errorTab)}
            onClick={() => this.switchTab('edit')}>
            Edit
          </li>

          <li
            className={cx(styles.tab, activeTab === 'preview' && styles.activeTab)}
            disabled={!value}
            onClick={() => this.switchTab('preview')}>
            Preview
          </li>
        </ul>
        <div className={cx(styles.wrapper, errored && styles.wrapperError)}>
          {Boolean(activeTab === 'edit') && (
            <>
              <ul className={styles.toolbar} ref={el => (this.toolbar = el)}>
                {/* TODO: refactor these as buttons */}
                <li className={styles.toolbarItem} onClick={() => this.insertMarkdown('# ')} aria-label="Heading 1">
                  <AccessibleIcon icon={TypographyHeading1Icon} size={20} color={colors.jumbo} />
                </li>
                <li className={styles.toolbarItem} onClick={() => this.insertMarkdown('## ')} aria-label="Heading 2">
                  <AccessibleIcon icon={TypographyHeading2Icon} size={20} color={colors.jumbo} />
                </li>
                <li className={styles.toolbarItem} onClick={() => this.insertMarkdown('### ')} aria-label="Heading 3">
                  <AccessibleIcon icon={TypographyHeading3Icon} size={20} color={colors.jumbo} />
                </li>
                <li className={styles.toolbarSeparator} />
                <li className={styles.toolbarItem} onClick={() => this.insertMarkdown('**', '**')} aria-label="Bold text">
                  <AccessibleIcon icon={TypographyBoldIcon} size={20} color={colors.jumbo} />
                </li>
                <li className={styles.toolbarItem} onClick={() => this.insertMarkdown('_', '_')} aria-label="Italic text">
                  <AccessibleIcon icon={TypographyItalicIcon} size={20} color={colors.jumbo} />
                </li>
                <li className={styles.toolbarItem} onClick={() => this.insertMarkdown('~~', '~~')} aria-label="Strikethrough text">
                  <AccessibleIcon icon={TypographyStrikethroughIcon} size={20} color={colors.jumbo} />
                </li>
                <li className={styles.toolbarSeparator} />
                <li className={styles.toolbarItem} onClick={() => this.insertMarkdown('> ')} aria-label="Quote text">
                  <AccessibleIcon icon={QuoteIcon} size={20} color={colors.jumbo} />
                </li>
                <li className={styles.toolbarItem} onClick={this.insertHyperlink} aria-label="Hyperlink">
                  <AccessibleIcon icon={HyperlinkIcon} size={20} color={colors.jumbo} />
                </li>
                <li className={styles.toolbarItem} onClick={this.insertMarkdownUnorderedList} aria-label="Unordered list">
                  <AccessibleIcon icon={ListUnorderedIcon} size={20} color={colors.jumbo} />
                </li>
                <li className={styles.toolbarItem} onClick={this.insertMarkdownOrderedList} aria-label="Ordered list">
                  <AccessibleIcon icon={ListOrderedIcon} size={20} color={colors.jumbo} />
                </li>
                <li className={styles.toolbarSeparator} />
                <li className={styles.toolbarItem} onClick={() => window.open('https://markdown-it.github.io/')}>
                  <AccessibleIcon icon={QuestionCircleIcon} size={20} color={colors.jumbo} />
                </li>
              </ul>
              <textarea
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...props}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...input}
                className={cx(styles.editor, editorSize(size))}
                ref={el => (this.editor = el)}
                onChange={ev => {
                  const textarea = ev.target

                  this.setState({ cursorStart: textarea.selectionStart, cursorEnd: textarea.selectionEnd })

                  // Call change handlers if any
                  const handler = input.onChange || props.onChange
                  if (handler) handler(textarea.value)
                }}
                onFocus={ev => {
                  const focusHandler = input.onFocus || props.onFocus
                  if (focusHandler) focusHandler(ev)
                }}
                onBlur={ev => {
                  this.setState({ cursorStart: ev.target.selectionStart, cursorEnd: ev.target.selectionEnd })

                  const blurHandler = input.onBlur || props.onBlur
                  if (blurHandler) blurHandler(ev)
                }}
                onKeyDown={ev => {
                  if (ev.metaKey && !ev.ctrlKey && !ev.altKey) {
                    // If cmd is pressed (but no ctrl or alt), listen for the sortcodes of the toolbar
                    if (!ev.shiftKey && ev.keyCode === 66) {
                      // If cmd+b, insert bold
                      this.insertMarkdown('**', '**')
                    } else if (!ev.shiftKey && ev.keyCode === 73) {
                      // If cmd+i, insert italics
                      this.insertMarkdown('_', '_')
                    } else if (ev.shiftKey && ev.keyCode === 83) {
                      // If cmd+shift+s, insert strikethrough
                      this.insertMarkdown('~~', '~~')
                    } else if (!ev.shiftKey && ev.keyCode === 75) {
                      // If cmd+k, insert italics
                      this.insertHyperlink()
                    }
                  }

                  if (props.onKeyDown) props.onKeyDown(ev)
                }}
              />
            </>
          )}

          {Boolean(activeTab === 'preview') &&
            (value ? (
              <MarkdownRenderer source={value} className={cx(styles.preview, previewSize(previewHeight))} theme={theme} />
            ) : (
              <div className={styles.noPreview}>Nothing to preview</div>
            ))}
        </div>
        {Boolean(errored) && <FormErrorMessage text={meta.error} />}
      </div>
    )
  }
}

MarkdownEditor.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
  }),
  name: PropTypes.string,
  value: PropTypes.string,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'dark', 'tertiary', 'info']),
  size: PropTypes.oneOf(['', 'default', 'small', 'medium', 'large']),
  className: PropTypes.string,
  onChange: PropTypes.func,
}

MarkdownEditor.defaultProps = {
  meta: {},
  input: {},
  name: '',
  value: '',
  theme: 'primary',
  size: 'default',
}

export default MarkdownEditor
